// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__17wzM","obliqueLineWrap":"membershipbadge_obliqueLineWrap__gSCoZ","obliqueLine":"membershipbadge_obliqueLine__1_VSB"};